import React, { useEffect, useState } from 'react';
import { adminAPI } from '../../../services/authService';
import { notifyError } from '../../../utils/notify';

const ConfigVersions = () => {
  const [rows, setRows] = useState([]);
  const [message, setMessage] = useState('');
  useEffect(() => {
    adminAPI.getConfigVersions()
      .then((res) => {
        setRows(res?.data?.data || []);
        setMessage(res?.data?.message || '');
      })
      .catch(() => notifyError('Unable to load versions'));
  }, []);
  return (
    <div>
      <p className="ce-muted">{message || 'Draft/Publish/Rollback is disabled until ENABLE_CONFIG_PUBLISHING=true.'}</p>
      <div className="table-container">
        <table className="data-table">
          <thead>
            <tr><th>Scope</th><th>Key</th><th>Version</th><th>Status</th><th>Summary</th><th>Created</th></tr>
          </thead>
          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan={6} style={{ textAlign: 'center', color: '#64748b', padding: 24 }}>No versions yet</td></tr>
            ) : rows.map((v) => (
              <tr key={v.id}>
                <td>{v.scopeType}</td>
                <td>{v.scopeKey}</td>
                <td>{v.versionNumber}</td>
                <td>{v.status}</td>
                <td>{v.changeSummary || '—'}</td>
                <td>{v.createdAt ? new Date(v.createdAt).toLocaleString('en-IN') : '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ConfigVersions;
